export var itemsCategories = [{
  id: '1',
  name: 'General',
  description: null,
  copilot_prompts: []
}, {
  id: '2',
  name: 'Clima y reconocimiento',
  description: null,
  copilot_prompts: []
}, {
  id: '3',
  name: 'Desempeño',
  description: null,
  copilot_prompts: []
}, {
  id: '4',
  name: 'E-learning',
  description: null,
  copilot_prompts: []
}];